<script setup>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { Inertia } from "@inertiajs/inertia";
import { ref, computed, watch } from "vue";

const props = defineProps({
    title: String,
    module: {
        type: String,
        required: true // 'providers' or 'companies'
    },
    activeIndex: {
        type: Number,
        default: 0
    },
    // Optional: override individual tab labels by index.
    // e.g. :tabOverrides="['Unternehmensdetails']" replaces tab 0 only.
    tabOverrides: {
        type: Array,
        default: () => []
    }
});

const handleTabChange = (event) => {
    let url = `/management/${props.module}`;
    
    if (event.index === 1) {
        url += '/scheduler';
    } else if (event.index === 2) {
        url += '/special-days';
    }
    
    // Maintain query parameters (like ?provider= or ?company=)
    const urlParams = new URLSearchParams(window.location.search);
    const data = Object.fromEntries(urlParams.entries());
    
    Inertia.get(url, data, { 
        preserveState: true 
    });
};

const defaultTabs = computed(() => {
    if (props.module === 'providers') {
        return ['Mitarbeiter Liste', 'Arbeitszeiten Hub', 'Sondertage Hub'];
    }
    return ['Unternehmen Liste', 'Öffnungszeiten Hub', 'Sondertage Hub'];
});

const tabs = computed(() =>
    defaultTabs.value.map((label, i) =>
        props.tabOverrides[i] !== undefined ? props.tabOverrides[i] : label
    )
);

</script>

<template>
    <div class="mb-6">
        <div class="flex justify-between items-center mb-6">
            <h1 class="text-2xl font-bold text-gray-800">{{ title }}</h1>
            <slot name="actions" />
        </div>

        <TabView :activeIndex="activeIndex" @tab-change="handleTabChange" class="management-tabs">
            <TabPanel v-for="tab in tabs" :key="tab" :header="tab">
                <!-- Content is handled by the page, this is just for navigation -->
            </TabPanel>
        </TabView>
    </div>
</template>

<style scoped>
:deep(.management-tabs .p-tabview-panels) {
    display: none;
}
:deep(.management-tabs .p-tabview-nav) {
    background: transparent;
    border-bottom: 2px solid #f3f4f6;
}
:deep(.management-tabs .p-tabview-nav li .p-tabview-nav-link) {
    background: transparent;
    border: none;
    color: #6b7280;
    font-weight: 600;
    padding: 1rem 1.5rem;
    transition: all 0.2s;
}
:deep(.management-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
    color: #000;
    border-bottom: 2px solid #000;
}
</style>
